import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import localePt from '@angular/common/locales/pt';
import localeFrExtra from '@angular/common/locales/extra/br';
import { NotifierModule, NotifierOptions } from 'angular-notifier';
import { QuillModule } from 'ngx-quill';

import { ScopeComponent } from './scope.component';
import { AccordionComponent } from './dynamicScope/accordion/accordion.component';
import { GroupComponent } from './dynamicScope/group/group.component';
import { DatepickerComponent } from './dynamicScope/datepicker/datepicker.component';
import { TextComponent } from './dynamicScope/text/text.component';
import { SelectComponent } from './dynamicScope/select/select.component';
import { SectionComponent } from './dynamicScope/section/section.component';
import { SwitchComponent } from './dynamicScope/switch/switch.component';
import { TextareaComponent } from './dynamicScope/textarea/textarea.component';
import { UploadComponent } from './dynamicScope/upload/upload.component';
import { TaskComponent } from './task/task.component';
import { TaskCommentComponent } from './task/task-comment/task-comment.component';
import { ButtonLinkComponent } from './button-link/button-link.component';
import { DynamicItemConfig } from '../../dynamic/model/dynamic-item-config';
import { DynamicModule } from '../../dynamic/dynamic.module';

var dynamicItemConfigScope: DynamicItemConfig = {
  mapping: [
    { name: 'text', component: TextComponent },
    { name: 'number', component: TextComponent },
    { name: 'groupComponent', component: GroupComponent },
    { name: 'collection', component: SelectComponent },
    { name: 'section', component: SectionComponent },
    { name: 'upload', component: UploadComponent },
    { name: 'datepicker', component: DatepickerComponent },
    { name: 'textarea', component: TextareaComponent },
    { name: 'boolean', component: SwitchComponent },
    { name: 'accordion', component: AccordionComponent },
  ]
}

registerLocaleData(localePt, 'pt-BR', localeFrExtra);

const customNotifierOptions: NotifierOptions = {
  position: {
    horizontal: {
      position: 'right',
      distance: 12
    },
    vertical: {
      position: 'bottom',
      distance: 12,
      gap: 10
    }
  },
  theme: 'material',
  behaviour: {
    autoHide: 5000,
    onClick: 'hide',
    onMouseover: 'pauseAutoHide',
    showDismissButton: true,
    stacking: 4
  },
  animations: {
    enabled: true,
    show: {
      preset: 'slide',
      speed: 300,
      easing: 'ease'
    },
    hide: {
      preset: 'fade',
      speed: 300,
      easing: 'ease',
      offset: 50
    },
    shift: {
      speed: 300,
      easing: 'ease'
    },
    overlap: 150
  }
};

@NgModule({
  imports: [
    NgSelectModule,
    CommonModule,
    BrowserModule,
    FormsModule,
    QuillModule,
    ReactiveFormsModule,
    DynamicModule.forRoot(dynamicItemConfigScope),
    NotifierModule.withConfig(customNotifierOptions),
  ],
  declarations: [
    ScopeComponent,
    AccordionComponent,
    GroupComponent,
    DatepickerComponent,
    TextComponent,
    SelectComponent,
    SectionComponent,
    SwitchComponent,
    TextareaComponent,
    UploadComponent, 
    TaskComponent, 
    TaskCommentComponent,
    ButtonLinkComponent
  ],
  entryComponents: [
    GroupComponent,
    UploadComponent,
    SectionComponent,
    SelectComponent,
    TextComponent,
    DatepickerComponent,
    TextareaComponent,
    SwitchComponent,
    AccordionComponent
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' },
  ]
})
export class ScopeModule {

}
